import React, { useState } from "react";

/**
 * Long product text folds down to a readable opening and expands in place.
 * Descriptions imported from a vendor's own shop can run to thousands of
 * characters, which would otherwise push the Add to Cart button off the screen.
 */
export const ExpandableText = ({
  text,
  wordLimit = 70,
  className = "",
  toggleClassName = "",
  testId = "expandable-text",
}) => {
  const [open, setOpen] = useState(false);
  const body = (text || "").trim();
  const words = body.split(/\s+/);
  const isLong = words.length > wordLimit;

  if (!body) return null;

  const shown = isLong && !open ? `${words.slice(0, wordLimit).join(" ")}…` : body;

  return (
    <>
      <p className={className} data-testid={testId}>
        {shown}
      </p>
      {isLong && (
        <button
          type="button"
          className={toggleClassName}
          onClick={() => setOpen(o => !o)}
          data-testid={`${testId}-toggle`}
        >
          {open ? "see less" : "see more"}
        </button>
      )}
    </>
  );
};

export default ExpandableText;
